// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * A reusable chip component for displaying shipment status.
 * Uses the backend-calculated status field.
 */
import { StatusChip } from '@/components/status-chip';
import { ShipmentDisplayStatus } from '@/shipment/api/types';
import { getShipmentStatusChipProps } from '@/shipment/constants/shipment-status';

interface ShipmentStatusChipProps {
  status: ShipmentDisplayStatus;
}

/**
 * Renders a status chip for a shipment based on its backend-calculated status.
 */
export function ShipmentStatusChip(props: ShipmentStatusChipProps) {
  const chipProps = getShipmentStatusChipProps(props.status);
  return <StatusChip {...chipProps} />;
}
